import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    tripTypeServiceV1ListTripTypes: build.query<
      TripTypeServiceV1ListTripTypesApiResponse,
      TripTypeServiceV1ListTripTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          trip_type_name: queryArg.tripTypeName,
          description: queryArg.description,
          is_freezer: queryArg.isFreezer,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    tripTypeServiceV1CreateTripType: build.mutation<
      TripTypeServiceV1CreateTripTypeApiResponse,
      TripTypeServiceV1CreateTripTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types`,
        method: "POST",
        body: queryArg.tripTypeV1CreateTripTypeReq,
      }),
    }),
    tripTypeServiceV1ActivateTripTypes: build.mutation<
      TripTypeServiceV1ActivateTripTypesApiResponse,
      TripTypeServiceV1ActivateTripTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types/activate`,
        method: "PATCH",
        body: queryArg.tripTypeV1TripTypeBulkStatusChangeReq,
      }),
    }),
    tripTypeServiceV1BatchCreateTripType: build.mutation<
      TripTypeServiceV1BatchCreateTripTypeApiResponse,
      TripTypeServiceV1BatchCreateTripTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types/batch`,
        method: "POST",
        body: queryArg.tripTypeV1BatchCreateTripTypeReq,
      }),
    }),
    tripTypeServiceV1DeactivateTripTypes: build.mutation<
      TripTypeServiceV1DeactivateTripTypesApiResponse,
      TripTypeServiceV1DeactivateTripTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types/deactivate`,
        method: "PATCH",
        body: queryArg.tripTypeV1TripTypeBulkStatusChangeReq,
      }),
    }),
    tripTypeServiceV1GetTripTypeDropdown: build.query<
      TripTypeServiceV1GetTripTypeDropdownApiResponse,
      TripTypeServiceV1GetTripTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/trip-types/dropdown` }),
    }),
    tripTypeServiceV1GetTripType: build.query<
      TripTypeServiceV1GetTripTypeApiResponse,
      TripTypeServiceV1GetTripTypeApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/trip-types/${queryArg.id}` }),
    }),
    tripTypeServiceV1UpdateTripType: build.mutation<
      TripTypeServiceV1UpdateTripTypeApiResponse,
      TripTypeServiceV1UpdateTripTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-types/${queryArg.id}`,
        method: "PUT",
        body: queryArg.tripTypeServiceV1UpdateTripTypeBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as tripTypeApi };
export type TripTypeServiceV1ListTripTypesApiResponse =
  /** status 200 A successful response. */ TripTypeV1ListTripTypesRes;
export type TripTypeServiceV1ListTripTypesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  tripTypeName?: string;
  description?: string;
  isFreezer?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type TripTypeServiceV1CreateTripTypeApiResponse =
  /** status 200 A successful response. */ TripTypeV1CreateTripTypeRes;
export type TripTypeServiceV1CreateTripTypeApiArg = {
  tripTypeV1CreateTripTypeReq: TripTypeV1CreateTripTypeReq;
};
export type TripTypeServiceV1ActivateTripTypesApiResponse =
  /** status 200 A successful response. */ TripTypeV1TripTypeBulkStatusChangeRes;
export type TripTypeServiceV1ActivateTripTypesApiArg = {
  tripTypeV1TripTypeBulkStatusChangeReq: TripTypeV1TripTypeBulkStatusChangeReq;
};
export type TripTypeServiceV1BatchCreateTripTypeApiResponse =
  /** status 200 A successful response. */ TripTypeV1BatchCreateTripTypeRes;
export type TripTypeServiceV1BatchCreateTripTypeApiArg = {
  tripTypeV1BatchCreateTripTypeReq: TripTypeV1BatchCreateTripTypeReq;
};
export type TripTypeServiceV1DeactivateTripTypesApiResponse =
  /** status 200 A successful response. */ TripTypeV1TripTypeBulkStatusChangeRes;
export type TripTypeServiceV1DeactivateTripTypesApiArg = {
  tripTypeV1TripTypeBulkStatusChangeReq: TripTypeV1TripTypeBulkStatusChangeReq;
};
export type TripTypeServiceV1GetTripTypeDropdownApiResponse =
  /** status 200 A successful response. */ TripTypeV1GetTripTypeDropdownRes;
export type TripTypeServiceV1GetTripTypeDropdownApiArg = void;
export type TripTypeServiceV1GetTripTypeApiResponse =
  /** status 200 A successful response. */ TripTypeV1TripTypeDetailRes;
export type TripTypeServiceV1GetTripTypeApiArg = {
  id: string;
};
export type TripTypeServiceV1UpdateTripTypeApiResponse =
  /** status 200 A successful response. */ TripTypeV1TripTypeMessageRes;
export type TripTypeServiceV1UpdateTripTypeApiArg = {
  id: string;
  tripTypeServiceV1UpdateTripTypeBody: TripTypeServiceV1UpdateTripTypeBody;
};
export type TripTypeV1TripTypeRes = {
  id?: string;
  trip_type_name?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  is_freezer?: boolean;
};
export type TripTypeV1TripTypePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type TripTypeV1ListTripTypesRes = {
  trip_types?: TripTypeV1TripTypeRes[];
  metadata?: TripTypeV1TripTypePaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TripTypeV1CreateTripTypeRes = {
  message?: string;
  id?: string;
};
export type TripTypeV1CreateTripTypeReq = {
  trip_type_name: string;
  description?: string;
  status: string;
  is_freezer?: boolean;
};
export type TripTypeV1TripTypeBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type TripTypeV1TripTypeBulkStatusChangeReq = {
  ids: string[];
};
export type TripTypeV1BatchCreateTripTypeResultItem = {
  id?: string;
  trip_type_name?: string;
  status?: string;
  error?: string;
};
export type TripTypeV1BatchCreateTripTypeRes = {
  message?: string;
  data?: TripTypeV1BatchCreateTripTypeResultItem[];
};
export type TripTypeV1BatchCreateTripTypeItem = {
  trip_type_name: string;
  description?: string;
  status: string;
  is_freezer?: boolean;
};
export type TripTypeV1BatchCreateTripTypeReq = {
  trip_types: TripTypeV1BatchCreateTripTypeItem[];
};
export type TripTypeV1TripTypeDropdownItem = {
  id?: string;
  trip_type_name?: string;
  value?: string;
};
export type TripTypeV1GetTripTypeDropdownRes = {
  trip_types?: TripTypeV1TripTypeDropdownItem[];
};
export type TripTypeV1TripTypeDetailRes = {
  id?: string;
  trip_type_name?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  is_freezer?: boolean;
};
export type TripTypeV1TripTypeMessageRes = {
  message?: string;
};
export type TripTypeServiceV1UpdateTripTypeBody = {
  trip_type_name: string;
  description?: string;
  is_freezer?: boolean;
};
export const {
  useTripTypeServiceV1ListTripTypesQuery,
  useTripTypeServiceV1CreateTripTypeMutation,
  useTripTypeServiceV1ActivateTripTypesMutation,
  useTripTypeServiceV1BatchCreateTripTypeMutation,
  useTripTypeServiceV1DeactivateTripTypesMutation,
  useTripTypeServiceV1GetTripTypeDropdownQuery,
  useTripTypeServiceV1GetTripTypeQuery,
  useTripTypeServiceV1UpdateTripTypeMutation,
} = injectedRtkApi;
